import { render, staticRenderFns } from "./SalaryDocument.vue?vue&type=template&id=b93dda42&scoped=true&"
import script from "./SalaryDocument.vue?vue&type=script&lang=js&"
export * from "./SalaryDocument.vue?vue&type=script&lang=js&"
import style0 from "./SalaryDocument.vue?vue&type=style&index=0&id=b93dda42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93dda42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAutocomplete,VBtn,VCard,VCol,VDataTable})
